





















































































































import { defineComponent, reactive } from '@vue/composition-api'
import moment from 'moment'
import { receiptSuppliers } from '@/types/receipt'
import { IUser } from '@/types/user'
import { UserRole } from '@/types/user'
import { publicationsStatus } from '@/types/questionnaire'
import { QuestionnaireEntity } from '../../../../api/@types'

type Props = {
  user: IUser
  isAutomatic: boolean
  questionnaires: QuestionnaireEntity[]
}

export default defineComponent({
  name: 'SearchInput',
  props: {
    user: {
      type: Object,
      required: true,
    },
    isAutomatic: {
      type: Boolean,
      default: true,
    },
    questionnaires: {
      type: Array,
      default: () => [],
    },
  },
  setup(props: Props, context) {
    const state = reactive({
      id: null,
      name: null,
      nameAdmin: null,
      supplier: null,
      releaseAt: null,
      finishAt: null,
      status: null,
    })

    const flags = reactive({
      releaseAtMenu: false,
      finishAtMenu: false,
    })

    const search = () => {
      const query = Object.entries(state)
        .filter(([_key, value]) => value !== null)
        .reduce((prev, [key, value]) => {
          prev[key] = ['releaseAt', 'finishAt'].includes(key)
            ? moment(value).toDate()
            : value
          return prev
        }, {} as any)

      context.emit('on-search', query)
    }

    const reset = () => {
      state.id = null
      state.name = null
      state.nameAdmin = null
      state.supplier = null
      state.releaseAt = null
      state.finishAt = null
      state.status = null

      context.emit('on-reset')
    }

    const qType = props.isAutomatic ? 'automatic' : 'manual'

    const questionnaireWithIds = props.questionnaires.map(q => ({
      id: q.id,
      name: `${q.id}: ${q.name}`,
    }))

    return {
      state,
      flags,
      receiptSuppliers,
      props,
      UserRole,
      publicationsStatus,
      search,
      reset,
      qType,
      questionnaireWithIds,
    }
  },
})
